import { Injector, Pipe, PipeTransform } from "@angular/core";
import { DecimalPipe } from "@angular/common";
@Pipe({
  name: "amountIndianUnit",
})
export class AmountIndianUnit implements PipeTransform {
  public constructor(private injector: Injector) { }

  transform(value: any, pipeToken: any, pipeArgs: any[]): any {
    let temp = pipeToken.split(":");
    if (!pipeToken) {
      return value;
    } else {
      const pipe = this.injector.get('DecimalPipe');
      return pipe.transform(value, '1.1-1');
    }
  }
}
